import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import axios from '../../../utils/axios';

export namespace IssueAccountCoupon {
  export type RequestType = {
    endDate: string;
    storeCouponPresetId: number;
    accountId: number;
  };

  export const useMutate = ({
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSuccess,
    ...options
  }: UseMutationOptions<AxiosResponse, AxiosError, RequestType> = {}) => {
    const mutation = useMutation(
      ({ accountId, endDate, storeCouponPresetId }) => {
        return axios.post(`/account-coupon`, {
          accountId,
          endDate,
          storeCouponPresetId
        });
      },
      {
        ...options
      }
    );

    return mutation;
  };
}
